<template>

  <div>

    <t-dialog-duplicate v-if="formDuplicateShow" :origin="formDuplicate.origin" :path-server="currentPage.path" :form-error="formDuplicateError"
                        v-model="formDuplicate" :title="currentPage.singularTitle" @onSubmit="onFlowDuplicated">

      <template #default="{status}">
        <t-input hide-label :status="status" v-model="formDuplicate.processFlowId" hidden/>
        <t-input hide-label :status="status" v-model="formDuplicate.processFlowStepId" hidden/>
        <t-input label="Nome da nova Etapa" :status="status" :add-error="formDuplicateError.name"
                 v-model="formDuplicate.changeName" required/>
        <t-input label="Duplicar campos" :status="status" v-model="formDuplicate.enableFields" checked/>
        <t-input label="Duplicar regras" :status="status" v-model="formDuplicate.enableRulers" checked/>
        <t-input label="Duplicar gatilhos" :status="status" v-model="formDuplicate.enableTriggers" checked/>


      </template>
    </t-dialog-duplicate>

    <ProcessFlowStepDialog :command="command"
                           :foreign-key="foreignKey"
                           :primary-key="form.processFlowStepId"
                           @onSubmit="onProcessFlowStepDialog"/>

    <b-modal @hidden="getList" no-close-on-backdrop no-close-on-esc size="lg" v-model="modalField"
             id="modal-process-flow-step-field"
             hide-footer
             :title="'Campos etapa: ' + modalFieldName">
      <ProcessFlowStepField v-if="modalField" :foreign-key="modalFieldProcessFlowStepId"/>
    </b-modal>

    <b-modal @hidden="getList" no-close-on-backdrop no-close-on-esc size="lg" v-model="modalRule"
             id="modal-process-flow-step-trigger"
             hide-footer
             :title="'Regras etapa: ' + modalRuleName ">
      <ProcessFlowStepRule v-if="modalRule" :foreign-key="modalRuleProcessFlowStepId"/>
    </b-modal>

    <b-modal @hidden="getList" no-close-on-backdrop no-close-on-esc size="lg" v-model="modalTrigger"
             id="modal-process-flow-step-trigger"
             hide-footer
             :title="'Gatilhos etapa: ' + modalTriggerName">

      <t-form-list-trigger v-if="modalTrigger" primary-key-column="processFlowStepTriggerId"
                           foreign-key-column-trigger="processFlowStepId"
                           path-trigger="production/process-flow-step-trigger"
                           :foreign-key="modalTriggerProcessFlowStepId"
                           :type-trigger="TriggerEventType.typeList.STEP"/>
    </b-modal>

    <t-form-list :generalErrors="generalErrors" sortable sortable-check-column="stepSequential" :items="items"
                 :fields="fields" :command="command" :user-auth="userAuth" :status="status"
                 :busy="!pageFormIsLoaded" :busy-form="!listFormIsLoaded" :busy-list="!listIsLoaded" :path="path"
                 primary-key-column="processFlowStepId" foreign-key-column="processFlowId"
                 :primary-key="form.processFlowStepId" :foreign-key="foreignKey"
                 @onChangeOrder="getList"
                 @onItemRead="onStepReadItem"
                 @onItemDelete="onItemDeleteDefault">

      <div class="ml-1 mb-3">

        <t-button @click="openStepInsert">
          <b-icon-node-plus/>
          {{ t('insert') + ' Etapa' }}
        </t-button>

      </div>

      <template #item(orderList)="{item}">
        <span class="badge badge-pill badge-light bg-light" v-show="item.stepSequential">{{ item.orderList }}</span>
      </template>

      <template #item(name)="{item}">


        <div v-if="item.stepSequential">

          <div v-if="doneStep.processFlowStepId === item.processFlowStepId">
            <b-icon-check-circle-fill class="text-success" v-b-tooltip.hover="'Etapa de finalização'"/>
            {{ item.name }}
            <b-icon-clock
                v-b-tooltip.hover="'Finalização automatica após '+ item.finishAutomaticallyDeadline + ' minutos'"
                v-if="item.finishAutomaticallyEnable"/>
          </div>
          <div v-else>
            <b-icon-arrow-down-circle-fill v-b-tooltip.hover="'Etapa sequêncial'"/>
            {{ item.name }}
            <b-icon-clock
                v-b-tooltip.hover="'Finalização automatica após '+ item.finishAutomaticallyDeadline + ' minutos'"
                v-if="item.finishAutomaticallyEnable"/>
          </div>


        </div>

        <div v-else>

          <div v-if="item.typeActionNotSequential === FlowStepNotSequenceActionType.type.EXECUTION_PARALLEL">

            <b-icon-menu-button-fill v-b-tooltip.hover="'Etapa em paralelo'"/>
            {{ item.name }}

            <div class="pl-3">
              <small>Durante</small> <b>{{ item.startStep }}</b> <br/>
              <small>Até</small> <b>{{ item.endStep }}</b>
            </div>


          </div>

          <div v-if="item.typeActionNotSequential === FlowStepNotSequenceActionType.type.FINAL_INSPECTION_SHIPPING">

            <b-icon-shield-fill-check v-b-tooltip.hover="'Inspeção final para expedições do produtos'"/>
            {{ item.name }}
            <br />
            <small>Etapa executada quando for expedido ao cliente</small>


          </div>

          <div v-else>

            <b-icon-arrow-up-right-circle-fill v-b-tooltip.hover="'Etapa com acionamento somente de forma especial'"/>
            {{ item.name }}
            <b-icon-arrow-right/>
            <span class="pl-1"
                  v-if="item.typeActionNotSequential === FlowStepNotSequenceActionType.type.DELEGATE_RULES"><b> Definido pelas regras </b></span>
            <span class="pl-1" v-else><b>{{ item.goStep }}</b></span>

            <b-icon-clock
                v-b-tooltip.hover="'Finalização automatica após '+ item.finishAutomaticallyDeadline + ' minutos'"
                v-if="item.finishAutomaticallyEnable"/>

          </div>


        </div>


      </template>

      <template #item(statusOperational)="{item}">

        <div v-if="doneStep.processFlowStepId === item.processFlowStepId">
          {{ item.statusOperational }}
          <b-icon-arrow-right/>
          <span class="pl-1"><b>{{ statusDone.name }}</b></span>
        </div>
        <div v-else>{{ item.statusOperational }}</div>


      </template>

      <template #append-default-buttons="{item}">
        <b-button @click="openDialogDuplicate(item.processFlowStepId, item.name)"
                  class="opacity-6-hover"
                  v-if="userAuth.validation.validationCreate" size="sm" variant="outline" v-b-tooltip.hover.ds500
                  title="Duplicar etapa">
          <b-icon-files variant="primary"/>
        </b-button>
      </template>


      <template #list-buttons="{item}">

        <b-button-group size="sm" class="mr-4">
          <t-button small @click="openModalField(item.processFlowStepId, item.name)" class="pr-2">
            <b-icon-card-text></b-icon-card-text>
            Campos
            <div class="mr-1 badge badge-sm badge-pill bg-warning text-black-50" style="right: -3px; top:-7px;"
                 v-if="item.qtdFields > 0">{{ item.qtdFields }}
            </div>

          </t-button>
          <t-button small @click="openModalRule(item.processFlowStepId, item.name)">
            <b-icon-shield-exclamation></b-icon-shield-exclamation>
            Regras
            <div class="mr-1 badge badge-sm badge-pill bg-warning text-black-50" style="right: -3px; top:-7px;"
                 v-if="item.qtdRules > 0">{{ item.qtdRules }}
            </div>
          </t-button>
          <t-button small @click="openModalTrigger(item.processFlowStepId, item.name)">
            <b-icon-bezier2></b-icon-bezier2>
            Gatilhos
            <div class="mr-1 badge badge-sm badge-pill bg-warning text-black-50" style="right: -3px; top:-7px;"
                 v-if="item.qtdTriggers > 0">{{ item.qtdTriggers }}
            </div>
          </t-button>
        </b-button-group>


      </template>

    </t-form-list>

  </div>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import pageFormListMixin from "@/mixins/page/pageFormListMixin"
import ProcessFlowStepField from "@/views/modules/production/ProcessFlow/ProcessFlowStepField";
import tFormList from "@/components/template/form/list/t-form-list"

import ProcessFlowStepDialog from "@/views/modules/production/ProcessFlow/ProcessFlowStepDialog";
import ProcessFlowStepRule from "@/views/modules/production/ProcessFlow/ProcessFlowStepRule";

import tFormListTrigger from "@/components/template/form/list/t-form-list-trigger"

import TriggerEventType from "@/model/types/resource/TriggerEventType";
import TypeStatusProductionService from "@/services/modules/production/TypeStatusProduction.service";

import FlowStepNotSequenceActionType from "@/model/types/modules/production/FlowStepNotSequenceActionType";
import ui from "@/assets/scripts/ui";
import TDialogDuplicate from "@/components/template/dialog/t-dialog-duplicate";


export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageFormListMixin],
  components: {
    tFormList,
    ProcessFlowStepDialog,
    ProcessFlowStepField,
    ProcessFlowStepRule,
    tFormListTrigger,
    TDialogDuplicate
  },
  name: 'ProcessFlowStep',
  data() {
    return {
      FlowStepNotSequenceActionType,
      TriggerEventType,
      TypeStatusProduction: TypeStatusProductionService,
      path: "production/process-flow-step", //Utilizar somente quando fora do padrão
      foreignKeyColumn: "processFlowId", //Utilizar quando usar Tabs com outros componentes
      statusDone: {},
      fields: [
        {keyRead: "processFlowStepId", keyDelete: "processFlowStepId"},
        {key: "orderList", label: "#", cols: "1",},
        {key: "name", label: "Etapa", cols: "3"},
        {key: "statusOperational", label: "Status", cols: "3"},
        {key: "responsibleName", label: "Resp.", cols: "3"},

      ],
      form: {
        processFlowStepId: 0,
        processFlowId: this.foreignKey,
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      doneStep: {},
      modalField: false,
      modalFieldName: "",
      modalFieldProcessFlowStepId: 0,
      modalRule: false,
      modalRuleName: "",
      modalRuleProcessFlowStepId: 0,
      modalTrigger: false,
      modalTriggerName: "",
      modalTriggerProcessFlowStepId: 0,
      formDuplicateShow: false,
      formDuplicate: {
        processFlowId: 0,
        processFlowStepId: 0,
        changeName: "",
        enableFields: true,
        enableRulers: true,
        enableTriggers: true,
        origin: "",
      },
      formDuplicateError: {
        name: "",
      }
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    defaultForm() {


    },

    mountedPrepare() {

      this.mountedPrepareFormListDefault()

    },

    async mountedContinued() {

      await TypeStatusProductionService.getStatusFinishSuccess()
          .then(statusDone => this.statusDone = statusDone)
          .catch(error => this.responseError(error))

      await this.getList()

    },

    async onSubmit() {


    },

    mountedList() {

      // Manipulação da listagem após carregando
      //--------------------------------------
      let newItems = []
      let findDoneStep = null
      this.doneStep = {}

      for (let item of this.items) {
        if (!item.stepSequential) {
          if (item.typeActionNotSequential === FlowStepNotSequenceActionType.type.EXECUTION_PARALLEL) {
            item.class = "bg-focus-light"
          } else if (item.typeActionNotSequential === FlowStepNotSequenceActionType.type.FINAL_INSPECTION_SHIPPING) {
              item.class = "bg-info-light"
          } else {
            item.class = "bg-light"

          }

        } else {
          findDoneStep = item
        }
        newItems.push(item)
      }

      if (findDoneStep !== null) {
        this.doneStep = findDoneStep
        newItems.find(a => a.processFlowStepId === findDoneStep.processFlowStepId).class = "bg-success-light"
      }


      this.items = newItems
      //--------------------------------------



      this.listIsLoaded = true


    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    async onProcessFlowStepDialog() {

      //Atualiza a listagem
      await this.getList()

    },
    openStepInsert() {
      this.form.processFlowStepId = 0
      this.command = 'insert'
      this.openDialogForm('modal-process-flow-step')
    },
    onStepReadItem(id) {
      this.form.processFlowStepId = id
      this.command = 'update'
      this.openDialogForm('modal-process-flow-step')
    },
    openModalField(id, name) {
      this.modalField = true
      this.modalFieldName = name
      this.modalFieldProcessFlowStepId = id
    },
    openModalTrigger(id, name) {
      this.modalTrigger = true
      this.modalTriggerName = name
      this.modalTriggerProcessFlowStepId = id
    },
    openModalRule(id, name) {

      this.modalRule = true
      this.modalRuleName = name
      this.modalRuleProcessFlowStepId = id

    },
    openDialogDuplicate(id, origin) {

      this.formDuplicateShow = true
      this.formDuplicate.processFlowId = this.foreignKey
      this.formDuplicate.processFlowStepId = id
      this.formDuplicate.origin = origin
      this.formDuplicate.changeName = ""

      this.openDialogForm('modal-duplicate')

    },

    onFlowDuplicated(item) {

      this.formDuplicate.changeName = ""

      ui.toast(this, "Duplicada", "Nova etapa <b>" + item.name + "</b> duplicada com sucesso!", "success", "b-toaster-top-center", true)

      this.getList()
    },

    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedFormList()

    await this.mountedContinued()

  },
}
</script>
